import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    let isLtr = true;

    element.style.position = "fixed";
    element.style.top = (window.innerHeight * 0.226) + "px";  
    element.style.width = (window.innerWidth * 0.080) + "px";
    
    if (document.dir == 'rtl') {
        isLtr = false;
    }
    if(isLtr){
     element.style.left = (window.innerWidth * 0.619) + "px";

    }else{
        element.style.left = (window.innerWidth * 0.617) + "px";
    }
}

const booths: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default booths;
